import { logger } from '$utils'
import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import useStockStore from '../../../store'

export default async function loader({ params }) {
  logger.debug(
    '[loader] About to await AppState being ready in Edit Supplier Statement loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Edit Supplier Statement loader'
  )

  const getSupplierStatement = params.statementId
    ? useStockStore.getState().getSupplierStatement(params.statementId)
    : []

  return defer({
    data: Promise.all([getSupplierStatement])
      .then(() => true)
      .catch((error) => {
        logger.error('Edit Supplier Statement Promise.all error', error)
        return false
      }),
  })
}
